import { render, staticRenderFns } from "./MStepTwo.vue?vue&type=template&id=f857a940&"
import script from "./MStepTwo.vue?vue&type=script&lang=js&"
export * from "./MStepTwo.vue?vue&type=script&lang=js&"
import style0 from "./MStepTwo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports